<div #t style="height:0px;width:0px;"></div>
<!--LANGUAGE OVERLAY-->
<div id="backgroundOverlayLanguage" class="fade-in fade-out" *ngIf="showLanguage" (click)="onToggleLanguage()"></div>
<!--end backgroundOverylayLanguage-->
<!--SIGN IN OVERLAY-->
<div id="backgroundOverlaySignIn" class="fade-in fade-out" *ngIf="showSignIn" (click)="onToggleSignIn()"></div>
<!--end backgroundOverlaySignIn-->
<!--PROFILE OVERLAY-->
<div id="backgroundOverlayProfile" class="fade-in fade-out" *ngIf="showProfile" (click)="onToggleProfile()"></div>
<!--end backgroundOverlayProfile-->
<!--<div class="header-container row">
  <app-logout-header></app-logout-header>
</div>
<div class="header-container row">
  <app-logged-in-header></app-logged-in-header>
</div>-->
<!--FORGOT PASSWORD CONFIRMATION DIALOG-->
<!--FORGOT USERNAME CONFIRMATION DIALOG-->
<div class="forgotUsernameConfirmation-wrapper">
  <kendo-dialog *ngIf="openedForgotUsernameConfirmation" (close)="close('cancel')" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center; font-size:20px;">
      <strong> {{header.thanksLbl?header.thanksLbl:headerText.thanksLbl}}&nbsp;</strong> <!--Afsana K50-1105-Part2 removed comma-->
      <br />
      {{header.userNameSentToMailLbl?header.userNameSentToMailLbl:headerText.userNameSentToMailLbl}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton class="" (click)="closeForgotUsernameConfirmation()">
        {{header.okLbl?header.okLbl:headerText.okLbl}}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
<!--END FORGOT USERNAME CONFIRMATION DIALOG-->

<div class="forgotPasswordConfirmation-wrapper">
  <kendo-dialog *ngIf="openedForgotPasswordConfirmation" (close)="close('cancel')" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center; font-size:20px;">
      <strong> {{header.thanksLbl?header.thanksLbl:headerText.thanksLbl}}&nbsp;</strong> <!--Afsana K50-1105-Part2 removed comma-->
      <br />
      {{header.newPasswordSentToMailLbl?header.newPasswordSentToMailLbl:headerText.newPasswordSentToMailLbl}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton class="" (click)="closeForgotPasswordConfirmation()">
        {{header.okLbl?header.okLbl:headerText.okLbl}}
      </button>
      <!--<button kendoButton (click)="close('yes')" primary="true">Yes</button>-->
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
<!--END FORGOT PASSWORD CONFIRMATION DIALOG-->
<!-- Logged out HEADER CONTAINER-->
<div class="header-container" *ngIf="!isAuthenticated">
  <div class="mainMenu headerSpacer">
    <span>&nbsp;</span>
  </div>
  <!--Logo-->
  <div class="logo" style="vertical-align:central">
    <a [routerLink]="['/']">
      <img src="../../../assets/images/KawneerDirect_logo.gif" alt="Kawneer logo">
    </a>
  </div>
  <!--end Logo-->
  <div class="login-bridge-block"></div>
  <!--Account-->
  <div class="account-container" style="vertical-align:central">
    <div class="account-menu-container">
      <!--Account List Items-->
      <ul class="account-list-items">
        <li style="vertical-align:central">
          <a href="https://www.kawneer.com/support-and-training/find-your-nearest-sales-rep/" target="_blank">
            Find Kawneer Sales Representative
          </a>
        </li>
        <li class="fade-on-hover language" #language (click)="onToggleLanguage()">
          <span class="k-icon k-i-globe-outline"></span><span class="k-icon k-i-arrow-60-down"></span>
          <!--Language Pop up-->
          <kendo-popup [anchor]="language" *ngIf="showLanguage" class="language-container" id="language-dropdown"
                       (click)="onToggleLanguage()">
            <div class="language-content">
              <ul>
                <li *ngFor="let language of languages" (click)="setLanguage(language.id)">
                  <a>
                    <img [src]="language.image">&nbsp;{{language.value}}
                  </a>
                </li>
              </ul>
            </div>
            <!--end language-content-->
          </kendo-popup>
          <!--END Language Pop Up-->
        </li>
        <li class="login fade-on-hover" #signIn (click)="showSignInBox()">
          <button class="sign-in-button" kendoButton primary="true">
            <!--{{signInLanguageLabel}}-->
            {{header.signInLbl?header.signInLbl:headerText.signInLbl}}
          </button>
        </li>
      </ul>
      <!--end Account List Items-->
    </div>
    <!--end menu-container-->
  </div>
  <kendo-popup id="sign-in-dropdown" [anchor]="signIn" (anchorViewportLeave)="anchorViewportLeave();" *ngIf="showSignIn"
               class="sign-in-container">
    <div class="signIn-content col-xs-12 col-sm-12">
      <form class="k-form">
        <label class="k-form-field">
          <span>
            <!--{{userIdLanguageLabel}}<span class="k-required requiredField">*</span>-->
            {{header.userNameLbl?header.userNameLbl:headerText.userNameLbl}}<span class="k-required requiredField">*</span>
          </span>
          <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
          <input #useridInput [(ngModel)]="userId" name="userId" class="k-textbox pwaInput"
                (keyup.enter)="login(); $event.preventDefault()" />
        </label>

        <label class="k-form-field">
          <span>
            <!--{{passWordLanguageLabel}}<span class="k-required requiredField">*</span>-->
            {{header.passwordLbl?header.passwordLbl:headerText.passwordLbl}}<span class="k-required requiredField">*</span>
          </span>
          <input class="k-textbox pwaInput" [(ngModel)]="userPassword" id="userPassword" name="userPassword" type="password"
                (keydown.enter)="login(); $event.preventDefault()" />
        </label>

        <button kendoButton primary="true" type="button" id="signInButton"
                class="mt-3 mb-3 k-button col-sm-12 sign-in-button" (click)="login()" #focusableSubmit>
          <!--{{signInLanguageLabel}}-->
          {{header.signInLbl?header.signInLbl:headerText.signInLbl}}
        </button>
        <label>
          {{invalidUserCredential}}
        </label>
        <div *ngIf="showLoginAttempt">
          <label>
            {{loginAttemptMessage}}
          </label>
          <!--start warningMessage-wrapper-->
          <div class="warningMessage-wrapper">
            <kendo-dialog *ngIf="openedwarningMessage" (close)="close('continue')" [minWidth]="250" [width]="550">
              <p style="margin: 30px; text-align: center; font-size: 20px; color: black">
                <b>Warning:</b> Invalid Password
              </p>
              <p style="margin: 30px; text-align: justify; font-size:15px;color:black">
                {{header.warningMessageLbl?header.warningMessageLbl:headerText.warningMessageLbl}}
              </p>
              <div class="text-center">
                <button kendoButton primary=true class="k-button mr-2" (click)="openForgotPasswordDialog()" style="border-color: #f55f54!important ">
                  {{header.resetPasswordLbl?header.resetPasswordLbl:headerText.resetPasswordLbl}}
                </button>
                <button kendoButton class="k-button" (click)="closeWarningMessage()">
                  {{header.continueLbl?header.continueLbl:headerText.continueLbl}}
                </button>
              </div>
            </kendo-dialog>
          </div>
          <!--end warningMessage-wrapper-->
        </div>

        <div class="text-right">
          <a *ngIf="!openedForgotUsername" (click)="openForgotUsernameDialog()">{{header.forgetUserNameLbl?header.forgetUserNameLbl:headerText.forgetUserNameLbl}}?</a>
        </div>
        <!--FORGOT USERNAME DIALOG-->
        <div class="form-control-lg form-control-sm">
          <kendo-dialog *ngIf="openedForgotUsername" (close)="close('cancel')">
            <form [formGroup]="forgotUsernameForm" (ngSubmit)="closeForgotUsernameDialog()">
              <label class="k-form-field">
                <span style="margin: 30px; text-align: center; font-size:20px;">
                  {{header.forgetUserNameUserLastNameMessageLbl1?header.forgetUserNameUserLastNameMessageLbl1:headerText.forgetUserNameUserLastNameMessageLbl1}}<span class="k-required requiredField">*</span>
                </span>
                <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
                <input kendoTextBox formControlName="userLastName"
                       [ngClass]="{ 'ng-invalid ng-touched': submitted && f.email.errors }" />
              </label>
              <label class="k-form-field">
                <span style="margin: 30px; text-align: center; font-size:20px;">
                  {{header.forgetUserNameMessageLbl1?header.forgetUserNameMessageLbl1:headerText.forgetUserNameMessageLbl1}}<span class="k-required requiredField">*</span>
                </span>
                <input kendoTextBox formControlName="email"
                       [ngClass]="{ 'ng-invalid ng-touched': submitted && f.email.errors }" />
              </label>
              <div class="text-center">
                <button kendoButton primary=true class="k-button mr-2" (click)="closeForgotUsernameDialog()">
                  {{header.continueLbl?header.continueLbl:headerText.continueLbl}}
                </button>
                <button kendoButton class="k-button" (click)="forgotUsernameCancel()">
                  {{header.cancelLbl?header.cancelLbl:headerText.cancelLbl}}
                </button>
              </div>
              <!--end text-center-->
            </form>
          </kendo-dialog>
        </div>
        <!--END FORGOT USERNAME DIALOG-->
        <div class="text-right">
          <a *ngIf="!openedForgotPassword" (click)="openForgotPasswordDialog()">{{header.forgetPasswordLbl?header.forgetPasswordLbl:headerText.forgetPasswordLbl}}?</a>
        </div>
        <!--FORGOT PASSWORD DIALOG-->
        <div class="form-control-lg  form-control-sm">
          <kendo-dialog *ngIf="openedForgotPassword" (close)="close('cancel')">
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="closeForgotPasswordDialog()">

              <!--end confirmation-message-->
              <label class="k-form-field">
                <span style="margin: 30px; text-align: center; font-size:20px;">
                  {{header.forgetPasswordUserNameMessageLbl1?header.forgetPasswordUserNameMessageLbl1:headerText.forgetPasswordUserNameMessageLbl1}}<span class="k-required requiredField">*</span>
                </span>
                <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
                <input kendoTextBox formControlName="userName"
                       [ngClass]="{ 'ng-invalid ng-touched': submitted && f.email.errors }" />
              </label>
              <label class="k-form-field">
                <span style="margin: 30px; text-align: center; font-size:20px;">
                  {{header.forgetPasswordMessageLbl1?header.forgetPasswordMessageLbl1:headerText.forgetPasswordMessageLbl1}}<span class="k-required requiredField">*</span>
                </span>
                <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
                <input kendoTextBox formControlName="email"
                       [ngClass]="{ 'ng-invalid ng-touched': submitted && f.email.errors }" />
              </label>

              <div class="text-center">

                <button kendoButton primary=true class="k-button mr-2" (click)="closeForgotPasswordDialog()">
                  {{header.continueLbl?header.continueLbl:headerText.continueLbl}}
                </button>
                <button kendoButton class="k-button" (click)="forgotPasswordCancel()">
                  {{header.cancelLbl?header.cancelLbl:headerText.cancelLbl}}

                </button>
              </div>
              <!--end text-center-->
            </form>
          </kendo-dialog>
        </div>

        <!--END FORGOT PASSWORD DIALOG-->
        <!--FORGOT PASSWORD OTP DIALOG-->
        <div class="form-control-lg  form-control-sm">
          <kendo-dialog *ngIf="openedForgotPasswordOtp" (close)="close('cancel')">

            <form [formGroup]="forgotPasswordOtpForm" style="border:3px solid black">
              <div *ngIf="!openedForgotPasswordOtpSuccess">
                <label class="k-form-field text-center">
                  <span style="margin: 30px; text-align: center; font-size:15px;">
                    The last name and/or email address you have entered does not match our records.
                    <br />Please ensure you are entering the information submitted to Kawneer for account creation.
                  </span>
                </label>
                <div class="text-center">
                  <button kendoButton class="k-button" (click)="forgotPasswordOtpClose()">
                    {{header.closeotpLbl?header.closeotpLbl:headerText.closeotpLbl}}
                  </button>
                </div>
                </div>
                <div *ngIf="openedForgotPasswordOtpSuccess">
                  <div style="width:100%;font-size:20px; background-color:red;color:white;padding: 5px;">Verification Code</div>
                  <!--end confirmation-message-->
                  <label class="k-form-field text-center">
                    <span style="text-align: center; font-size:20px;">
                      {{header.forgetPasswordOTPMessageLbl?header.forgetPasswordOTPMessageLbl:headerText.forgetPasswordOTPMessageLbl}}
                    </span>
                  </label>
                  <label class="k-form-field text-center">
                    <span class="text-center" style="margin: 30px; text-align: center; font-size:20px;">
                      {{header.forgetPasswordOTPLbl?header.forgetPasswordOTPLbl:headerText.forgetPasswordOTPLbl}}<span class="k-required requiredField">*</span>
                    </span>
                    <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
                    <div style="display:block;margin-left:auto;margin-right:auto;width:40%;">
                      <input kendoTextBox formControlName="Otp"
                             [ngClass]="{ 'ng-invalid ng-touched': f.email.errors }" />
                    </div>
                  </label>
                  <div class="text-center">
                    <button kendoButton primary=true class="k-button mr-2" [disabled]="forgetPasswordInProcess" (click)="submitForgotPasswordOTPDialog()">
                      {{header.submitotpLbl?header.submitotpLbl:headerText.submitotpLbl}}
                    </button>
                    <button kendoButton primary=true class="k-button mr-2" [disabled]="forgetPasswordInProcess" (click)="forgotPasswordOtpResend()">
                      {{header.resendotpLbl?header.resendotpLbl:headerText.resendotpLbl}}
                    </button>
                    <button kendoButton class="k-button" (click)="forgotPasswordOtpClose()">
                      {{header.closeotpLbl?header.closeotpLbl:headerText.closeotpLbl}}
                    </button>
                  </div>
                  <label class="k-form-field text-center" *ngIf="submittedOtp">
                    <span style="margin: 30px; text-align: center; font-size:20px;" [style.color]="headerText.IsForgetpasswordResend ? 'green' : 'red'">
                      {{header.forgetPasswordOTPValidationMessagelbl?header.forgetPasswordOTPValidationMessagelbl:headerText.forgetPasswordOTPValidationMessagelbl}}
                    </span>
                  </label>
                </div>
                <!--end text-center-->
</form>
          </kendo-dialog>
        </div>

        <!--END FORGOT PASSWORD OTP DIALOG-->
        <!--Change Password By OTP DIALOG-->
        <section class="dialogSection" *ngIf="!changePasswordByOTP.isSuccess">
          <kendo-dialog *ngIf="changePasswordByOTP.opened">
            <form novalidate [formGroup]="changePasswordByOTPForm" (ngSubmit)="submitChangePasswordByOTP()">
              <div style="width:100%;font-size:20px; background-color:red;color:white;padding: 5px;">{{header.changePasswordByOTPLbl?header.changePasswordByOTPLbl:headerText.changePasswordByOTPLbl}}</div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <!--(start) Afsana Dec 5th 2023 visual password requirements code changes-->
                  <p style="text-align: left; font-size:18px;"><b>We will ask for this password whenever you sign-in.</b></p>
                  <div class="visual">
                    <label class="lblCls">{{header.newPasswordLbl?header.newPasswordLbl:headerText.newPasswordLbl}} <span class="requiredField">*</span></label>
                    <div class="form-inline">
                      <input id="newPassword" type="password" kendoTextBox class="kendoInput" name="newPassword"                             
                             (keyup)="validatechangePasswordByOTPForm();validateNewPassword();checkDisabledForgotPasswordByOTP()"
                             [ngClass]="{'borderRed':changePasswordByOTP.isEmptyNewPassword}"
                             formControlName="newPassword" />
                      <!--<span title="{{header.passwordFormatMatchLbl?header.passwordFormatMatchLbl:headerText.passwordFormatMatchLbl}}" *ngIf="changePasswordByOTP.isPasswordFormatInValid " kendoTooltip
        class="k-icon k-i-information k-i-info spanInfoIconCls"></span>-->
                    </div>
                  </div>
                  <div class="visual">
                    <label class="lblCls">{{header.confirmPasswordLbl?header.confirmPasswordLbl:headerText.confirmPasswordLbl}}<span class="requiredField">*</span></label>
                    <input id="confirmPassword" type="password" kendoTextBox class="kendoInput" name="confirmPassword"
                           (keyup)="validatechangePasswordByOTPForm();validateConfirmPassword();checkDisabledForgotPasswordByOTP()"
                           [ngClass]="{'borderRed':changePasswordByOTP.isEmptyConfirmPassword && changePasswordByOTP.isSubmitted}"
                           formControlName="confirmPassword" />

                  <!--<span title="{{header.confirmPasswordMatchLbl?header.confirmPasswordMatchLbl:headerText.confirmPasswordMatchLbl}}" *ngIf="changePasswordByOTP.isPasswordNotMatched" kendoTooltip
          class="k-icon k-i-information k-i-info spanInfoIconCls"></span>-->
                  </div>
                  <div id="message">
                    <span #minLengthIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">Minimum 14 or more characters</span><br />
                    <span #upperCaseIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">At least 1 Uppercase letter</span><br />
                    <span #lowerCaseIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">At least 1 Lowercase letter</span><br />
                    <span #numberIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">At least 1 Number</span><br />
                    <span #specialCharacterIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">At least 1 Special character <b>(!"&#64;"#$%^&*)</b></span><br />
                    <span #passwordMatchIcon class="img1" [ngClass]="{'cross-icon': true, 'check-mark-icon': false}">Both entries must match</span>
                  </div>
                </div>
              </div>
              <div class="dialog-btn-section">
                <!--<div class="row">
                  <div class="col-sm-12 float-left">
                    <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                  </div>
                </div>-->
                <div class="row">
                  <div class="col-sm-12 btn-align-center">
                    <div class="btn-group text-center" role="group">
                      <button type="Submit" class="m-3 btn btn-success dialogBtnSize" kendoButton [disabled]="passwordSaveInProcessByOTP" #saveForgotPassword>
                        {{header.saveLbl?header.saveLbl:headerText.saveLbl}}<kendo-loader *ngIf="passwordSaveInProcessByOTP" style="color:blue"></kendo-loader>
                      </button>
                      <!--(end) Afsana Dec 5th 2023 visual password requirements code changes-->
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </kendo-dialog>
        </section>
        <!--END Change Password By OTP DIALOG-->
        <section class="dialogSection" *ngIf="changePasswordByOTP.isSuccess && changePasswordByOTP.isSuccessOpened">
          <kendo-dialog title="{{header.changePasswordByOTPLbl?header.changePasswordByOTPLbl:headerText.changePasswordByOTPLbl}}"
                        (close)="closechangePasswordOTPDialog()">
            <form>
              <div class="form-group col-md-12">
                <label class="lblCls">{{header.changepwdmessage?header.changepwdmessage:headerText.changepwdmessage}}</label>
              </div>
            </form>
          </kendo-dialog>
        </section>
        <div class="text-right">
          <!--<a [routerLink]="['/new-user']" (click)="newUser()" class="">{{newUserLanguageLabel}}?</a>-->
          <a [routerLink]="['/new-user']" (click)="newUser()" class="">{{header.newUserLbl?header.newUserLbl:headerText.newUserLbl}}?</a>
        </div>
      </form>
    </div>
    <!--end Sign In Pop up FORM-->
  </kendo-popup>
</div>
<!--end Logged out HEADER CONTAINER-->
<!--Statrt Logged In header-container-->
<div class="header-container row" *ngIf="isAuthenticated">

  <!--Hamburger for Main Menu-->
  <div class="mainMenu">
    <app-menu [childMessage]="loggedInUser?.userFirstName"></app-menu>
  </div>
  <!--end Hamburger for Main Menu-->
  <!--<div *ngIf="showSpacer" class="mainMenu headerSpacer">
    <span>&nbsp;</span>
  </div>-->
  <!--Logo-->
  <div class="logo">
    <a [routerLink]="['/']">
      <img src="../../../assets/images/KawneerDirect_logo.gif" alt="Kawneer logo">
    </a>
  </div>
  <!--end Logo-->
  <!--HIDE AND SHOW THIS TO KEEP SIGN IN BUTTON FROM COLLAPSING TO THE LEFT WHEN USER IS LOGGED OUT-->
  <!--HIDE AND SHOW THIS TO KEEP SIGN IN BUTTON FROM COLLAPSING TO THE LEFT WHEN USER IS LOGGED OUT-->
  <!--<div class="login-bridge-block" *ngIf="showLoginBridgeBlock"></div>-->
  <!--end login-bridge-->
  <!--HIDE AND SHOW THIS TO KEEP SIGN IN BUTTON FROM COLLAPSING TO THE LEFT WHEN USER IS LOGGED OUT-->
  <!--HIDE AND SHOW THIS TO KEEP SIGN IN BUTTON FROM COLLAPSING TO THE LEFT WHEN USER IS LOGGED OUT-->
  <!--Search Content-->
  <div class="app-search-in-header-container">
    <div class="app-search">
      <div>
        <app-search></app-search>
      </div>
    </div>
    <!--end search-->
  </div>
  <!--end app-search-in-header-container-->
  <!--end Search Content-->
  <!--Account-->
  <div class="account-container">
    <div class="account-menu-container">

      <div class="row">
        <div class="greeting-container">
          <div class="greeting hideInResponsive">
            <app-sign-in>
            </app-sign-in>
          </div>

          <div class="signOut" #signOut>
            <button kendoButton class="hideInResponsive" (click)="logOut()">



              <!--{{signOutLanguageLabel}}-->
              {{header.signOutLbl?header.signOutLbl:headerText.signOutLbl}}
            </button>
          </div>
          <!--end signOut button-->
        </div>
        <!--end greeting-->

      </div>
      <!--end row-->
      <!--Account List Items-->
      <ul class="account-list-items account-list-items-pwa">

        <li class="fade-on-hover hideInResponsive" #language (click)="onToggleLanguage()">
          <span class="k-icon k-i-globe-outline"></span><span class="k-icon k-i-arrow-60-down"></span>


          <!--Language Pop up-->
          <kendo-popup [anchor]="language" *ngIf="showLanguage" class="language-container" id="language-dropdown"
                       (click)="onToggleLanguage()">
            <div class="language-content">
              <ul>
                <li *ngFor="let language of languages" (click)="setLanguage(language.id)">
                  <a>
                    <img [src]="language.image">&nbsp;{{language.value}}
                  </a>
                </li>
              </ul>
            </div>
            <!--end language-content-->
          </kendo-popup>
          <!--END Language Pop Up-->

        </li>
        <!--<li class="login fade-on-hover" #signIn (click)="onToggleSignIn()">
          <button class="sign-in-button" kendoButton primary="true">
            {{signInLanguageLabel}}
          </button>
        </li>-->

        <li class="profile fade-on-hover" #profile (click)="onToggleProfile();">
          <span class="k-icon k-i-user"></span>
        </li>
        <li [routerLink]="['cart']" (click)="gotoCart('/cart')" class="shopping-cart fade-on-hover">
          <span class="k-icon k-i-cart k-i-shopping-cart"></span>
          <span class="countOfCartItems" [ngClass]="{'background-transparent' : (totalCartItem$ | async)<=0}">
            {{(totalCartItem$ | async)>0 ? (totalCartItem$ | async) : ''}}
          </span>
        </li>

      </ul>
      <!--end Account List Items-->
    </div>
    <!--end menu-container-->
  </div>
  <!--end account-container-->
  <!--POP UPS and DIALOGS-->
  <!--Sign In Pop Up FORM-->
  <!--KENDO POP UP MESSAGE FOR LOGIN/LOGOUT SUCCESS-->
  <!--Change Customer popup --Start-->
  <kendo-dialog title="{{header.changeCustomerLbl?header.changeCustomerLbl:headerText.changeCustomerLbl}}" *ngIf="changeCustomerDialog" (close)="closeChangeCustomerDialog()">
    <div class=" col-xs-12 col-sm-12">
      <form class="k-form" [formGroup]="changeCustomerForm">
        <div>
          <span>{{header.loggedInCustomerLbl?header.loggedInCustomerLbl:headerText.loggedInCustomerLbl}}: <b>{{loggedInUser.customerName}} ({{ loggedInUser?.customerNumber}})</b></span>
          <br /><br />
          <!--formControlName="customerName" [(ngModel)]="newUser.defaultCustomer"-->
          <kendo-dropdownlist class="txt-size"
                              [data]="filteredCustomerItems"
                              [textField]="'customerNameToDisplay'"
                              [filterable]="true"
                              [valueField]="'customerNumber'"
                              (selectionChange)="customerChangeSelected($event)"
                              (close)="onClosecustomerChange($event)"
                              (filterChange)="handleCustomerFilter($event)">
          </kendo-dropdownlist>

          <!--<kendo-autocomplete class="col" #customerName name="customerName"
                              [data]="filteredCustomerItems "
                              formControlName="customerName"
                              [valueField]="'fullCustomer'"
                              placeholder="Please type a Customer Name"
                              [virtual]="true"
                              [filterable]="true"
                              [highlightFirst]="false"
                              (filterChange)="handleCustomerFilter($event)"
                              (valueChange)="customerChangeSelected($event)"
                              [loading]="customerSearchLoading | async">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>

              <ng-container *ngFor="let substring of splitText(dataItem.fullCustomer)">
                <ng-container *ngIf="substring.toLowerCase() === currentInputValueInItemSearch.toLowerCase();
            else boldTemplateName
          ">
                  <span>{{ substring }}</span>
                </ng-container>
                <ng-template #boldTemplateName>
                  <b>{{ substring }}</b>
                </ng-template>
              </ng-container>
            </ng-template>

            <ng-template kendoAutoCompleteNoDataTemplate>
              <div *ngIf="showSuggestionBox">
                <h4>
                  <span class="k-icon k-i-warning"></span>
                  <br /><br />
                  No items match
                  <br />
                  "{{ currentInputValueInItemSearch }}"
                </h4>
              </div>
            </ng-template>
          </kendo-autocomplete>-->
        </div>
        <div style="text-align:right">
          <button kendoButton class="m-3 customerBtnCls dialogBtnSize" (click)="closeChangeCustomerDialog()">
            {{header.closeLbl?header.closeLbl:headerText.closeLbl}}
          </button>
          &nbsp;
          <button kendoButton class="m-3 btn btn-success customerBtnCls dialogBtnSize"
                  (click)="changeCustomerSubmit()">
            {{header.saveLbl?header.saveLbl:headerText.saveLbl}}
          </button>
        </div>

      </form>
    </div>
  </kendo-dialog>
  <!--Change Customer Pop up form end-->
  <div id="loginSuccess" *ngIf="userLoggedInSuccess">
    <p>Login Successful!!!</p>
  </div>

  <div id="logoutSuccess" *ngIf="userLoggedOutSuccess">
    <p>You are Logged out</p>
  </div>

  <div id="loginFail" *ngIf="userLoggedInFail">
    <p>Invalid Username or password</p>
  </div>

  <!--END KENDO POP UP MESSAGE FOR LOGIN SUCCESS-->
  <!--End Sign In Pop Up-->
  <!--END SIGN IN POPUP-->
  <!--MANAGE PROFILE DROPDOWN-->
  <kendo-popup id="profile-menu" [anchor]="profile" [animate]="animate" (anchorViewportLeave)="showProfile"
               class="profile-container" *ngIf="showProfile">
    <div class='profile-content'>
      <!-- User-defined profile-content -->
      <div class="profile-menu-header">
        <span class="k-icon k-i-user"></span><span class="logged-in-as">{{header.loggedInLbl?header.loggedInLbl:headerText.loggedInLbl}}</span>
        <span class="usernameDisplay">
          <strong><em>&nbsp;{{userId}}</em></strong>
        </span>
      </div>
      <div class="loggedUserCls row">
        <!--<span class="center-class">Account Details for {{loggedInUser?.customerNumber}}</span><br />-->
        <div class="col-6">
          <span>{{header.accountDetailsForLbl?header.accountDetailsForLbl:headerText.accountDetailsForLbl}}:{{ loggedInUser?.customerNumber}}</span><br />
          <span>{{header.nameLbl?header.nameLbl:headerText.nameLbl}}:{{ loggedInUser?.customerName}}</span> <br />
        </div>
        <div class="col-6">
          <button kendoButton (click)="logOut();closeProfile()" class="showSignOutInPwa">
            {{header.signOutLbl?header.signOutLbl:headerText.signOutLbl}}
          </button>
        </div>
      </div>
      <!--end profile-menu-header-->
      <div class="profile-menu-scroll">
        <ul class="profile-menu-list-items">
          <li kendoButton *ngIf="!openedProfile" (click)="openProfileDialog()">
            <span class="k-icon k-i-lock"></span>
            <a style="cursor:pointer">
              {{header.changePasswordLbl?header.changePasswordLbl:headerText.changePasswordLbl}}
            </a>
          </li>
          <li (click)="openChangeCustomerDialog();" *ngIf="isSuperAdmin || isCSR || isMultiCustomerAccount">
            <span class="k-icon k-i-user"></span>
            <a>
              {{header.changeCustomerLbl?header.changeCustomerLbl:headerText.changeCustomerLbl}}
            </a>
          </li>
          <li>
            <span class="k-icon k-i-file-vertical"></span>
            <a [routerLink]="['customer-multiplier-plan']" (click)="closeProfile()">
              {{header.viewCmpLbl?header.viewCmpLbl:headerText.viewCmpLbl}}
            </a>
          </li>
          <li *ngIf="hasAccountSummaryAccess">
            <span class="k-icon k-i-dollar"></span> <a [routerLink]="['account-summary']" (click)="closeProfile()">
              {{header.accountSummaryLbl?header.accountSummaryLbl:headerText.accountSummaryLbl}}
            </a>
          </li>
          <li *ngIf="canManageAddress">
            <span class="k-icon k-i-marker-pin"></span>
            <a [routerLink]="['manage-address']" (click)="closeProfile()">
              {{header.manageAddressLbl?header.manageAddressLbl:headerText.manageAddressLbl}}
            </a>
          </li>
          <li class="manageCompany" *ngIf="isVisibleManageCompany">
            <div class="manage-company-panelbar-wrapper">
              <kendo-panelbar class="manageCompany">
                <kendo-panelbar-item [icon]='"k-icon k-i-myspace"' title="{{header.manageCompanyLbl?header.manageCompanyLbl:headerText.manageCompanyLbl}}">
                  <ng-template kendoPanelBarContent>
                    <div class="manageCompanyLinks">
                      <div class="link">
                        <span class="listItem">
                          <span class="k-icon k-i-user"></span> <a [routerLink]="['manage-account']" (click)="closeProfile()">
                            {{header.manageAccountsLbl?header.manageAccountsLbl:headerText.manageAccountsLbl}}

                          </a>
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </kendo-panelbar-item>
              </kendo-panelbar>
            </div>
            <!--end panelbar-wrapper-->
          </li>

        </ul>
      </div>
    </div>

    <!--end profile-content-->
  </kendo-popup>
  <!--END MANAGE PROFILE DROPDOWN-->
  <!--MANAGE PROFILE DROPDOWN - CHANGE PASSWORD DIALOG-->
  <kendo-dialog title="{{header.changePasswordLbl?header.changePasswordLbl:headerText.changePasswordLbl}}" *ngIf="openedProfile" (close)="closeProfileDialog()" [minWidth]="250"
                [width]="450" class="passwordChange">
    <form novalidate [formGroup]="passwordForm" (ngSubmit)="savePassword()">
      <div class="form-row">

        <div class="form-group col-md-12">
          <label class="lblCls">{{header.oldPasswordLbl?header.oldPasswordLbl:headerText.oldPasswordLbl}} <span class="requiredField">*</span></label>
          <div class="form-inline">
            <input type="password" kendoTextBox class="kendoInput" name="oldpassword"
                   (blur)="validateNewPasswordForm();checkChangePasswordSave()"
                   [ngClass]="{'borderRed':changePasswordDialog.isInvalidOldPassword }"
                   formControlName="oldPassword" />
          </div>
        </div>
        <div class="form-group col-md-12">
          <label class="lblCls">{{header.newPasswordLbl?header.newPasswordLbl:headerText.newPasswordLbl}} <span class="requiredField">*</span></label>
          <div class="form-inline">
            <input type="password" kendoTextBox class="kendoInput" name="newpassword"
                   (blur)="checkNewPassword();checkChangePasswordSave()"
                   [ngClass]="{'borderRed':changePasswordDialog.isInvalidNewPassword || changePasswordDialog.isPasswordSameAsOld}"
                   formControlName="newpassword" />
            <span title="{{header.passwordFormatMatchLbl?header.passwordFormatMatchLbl:headerText.passwordFormatMatchLbl}}" *ngIf="changePasswordDialog.isPasswordFormatInValid " kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            <span title="{{header.passwordSameAsOldLbl?header.passwordSameAsOldLbl:headerText.passwordSameAsOldLbl}}" *ngIf="(changePasswordDialog.isPasswordSameAsOld && !changePasswordDialog.isPasswordFormatInValid)" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label class="lblCls">
            {{header.confirmPasswordLbl?header.confirmPasswordLbl:headerText.confirmPasswordLbl}}<span class="requiredField">*</span>
          </label>
          <input type="password" kendoTextBox class="kendoInput" name="confirmpassword"
                 [ngClass]="{'borderRed':changePasswordDialog.isInvalidConfirmPassword && changePasswordDialog.isSubmitted}"
                 (blur)="validateNewPasswordForm()" formControlName="confirmpassword" (keyup)="checkChangePasswordSave()" />
          <span title="{{header.confirmPasswordMatchLbl?header.confirmPasswordMatchLbl:headerText.confirmPasswordMatchLbl}}" *ngIf="changePasswordDialog.isPasswordNotMatched" kendoTooltip
                class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
        </div>
      </div>

      <div class="form-group">
        <!--<label for="oldpasswordId" class="col-sm-6 col-form-label">
          Old Password
        </label>
        <div class="col-xs-6">
          <input id="oldpasswordId" class="form-control" type="password" maxlength="30" formControlName="oldPassword">
        </div>-->
        <!--<div formGroupName="passwordGroup" class="form-group">
          <div class="form-group col-md-12">
            <label for="newpasswordId" class="lblCls">
              New Password
            </label>
            <div class="col-xs-6">
              <input id="newpasswordId" class="form-control" type="password" maxlength="30" formControlName="newpassword"
                     [ngClass]="{'is-invalid': passwordForm.get('passwordGroup').errors ||
                         ((passwordForm.get('passwordGroup.newpassword').touched ||
                         passwordForm.get('passwordGroup.newpassword').dirty) &&
                         !passwordForm.get('passwordGroup.newpassword').valid) }" />
              <div class="invalid-feedback">
                <div *ngIf="passwordForm.get('passwordGroup.newpassword').errors?.minlength">
                  <span class="k-icon k-i-warning k-i-exception k-i-error"></span>
                  Password must be at least 8 characters
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-md-12">
            <label for="confirmpasswordId" class="lblCls">
              Confirm New
              Password
            </label>
            <div class="col-xs-6">
              <input id="comfirmpasswordId" class="form-control" type="password" maxlength="30"
                     formControlName="confirmpassword" [ngClass]="{'is-invalid': passwordForm.get('passwordGroup').errors ||
                         ((passwordForm.get('passwordGroup.confirmpassword').touched ||
                         passwordForm.get('passwordGroup.confirmpassword').dirty) &&
                         !passwordForm.get('passwordGroup.confirmpassword').valid) }" />
              <div class="invalid-feedback">
                <div *ngIf="passwordForm.get('passwordGroup').errors?.match">
                  <span class="k-icon k-i-warning k-i-exception k-i-error"></span>
                  Passwords do not match
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <!--end row-->
      <!--<div class="container">
        <div class="text-center mt-5">
          <button kendoButton primary="true" *ngIf="!openedPassword" (click)="savePassword()" class=""
                  [title]="passwordForm.valid ? 'Save your entered data' : 'Disabled until the form data is valid'"
                  [disabled]="!passwordForm.valid" [icon]="'floppy'">
            Save
          </button>
        </div>
      </div>-->

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button type="submit" class="m-3 btn btn-success dialogBtnSize" kendoButton
                      [disabled]="disableChangePaswordSave">
                {{header.saveLbl?header.saveLbl:headerText.saveLbl}}<kendo-loader *ngIf="saveNewPasswordInProcess" style="color:blue"></kendo-loader>
              </button>&nbsp;&nbsp;
              <button type="reset" (click)="closeProfileDialog()" class=" m-3 btn k-button dialogBtnSize" [disabled]="saveNewPasswordInProcess" kendoButton>
                {{header.closeLbl?header.closeLbl:headerText.closeLbl}}
              </button>

            </div>
          </div>
        </div>
        <!--<div class="row">
          <div class="col-sm-12 float-left align-center">
            <p *ngIf="changedSuccess">
              {{header.passwordChangeSuccessfulLbl?header.passwordChangeSuccessfulLbl:headerText.passwordChangeSuccessfulLbl}}
            </p>
            <p *ngIf="changedFailed" style="margin-left:70px;color:red;">
              {{header.passwordFailedLbl?header.passwordFailedLbl:headerText.passwordFailedLbl}}
            </p>
          </div>
        </div>-->
      </div>
    </form>
  </kendo-dialog>
  <!--END MANAGE PROFILE DROPDOWN - CHANGE PASSWORD DIALOG-->
  <section class="dialogSection">
    <kendo-dialog title="{{header.changeDefaultPasswordLbl?header.changeDefaultPasswordLbl:headerText.changeDefaultPasswordLbl}}" *ngIf="defaultPassword.opened" (close)="closeDefaultPasswordDialog()" [minWidth]="250"
                  [width]="450">
      <form novalidate [formGroup]="defaultPasswordForm" (ngSubmit)="changeDefaultPassword()">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="lblCls">{{header.newPasswordLbl?header.newPasswordLbl:headerText.newPasswordLbl}} <span class="requiredField">*</span></label>
            <div class="form-inline">
              <input tabindex="1" type="password" kendoTextBox class="kendoInput" name="newPassword"
                     (blur)="validateDefaultPasswordForm();checkDisabledForgotPassword()"
                     [ngClass]="{'borderRed':defaultPassword.isEmptyNewPassword || defaultPassword.isPasswordFormatInValid }"
                     formControlName="newPassword" />
              <span title="{{header.passwordFormatMatchLbl?header.passwordFormatMatchLbl:headerText.passwordFormatMatchLbl}}" *ngIf="defaultPassword.isPasswordFormatInValid " kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{header.confirmPasswordLbl?header.confirmPasswordLbl:headerText.confirmPasswordLbl}}<span class="requiredField">*</span>
            </label>
            <input tabindex="2" type="password" kendoTextBox class="kendoInput" name="confirmPassword"
                   [ngClass]="{'borderRed':defaultPassword.isEmptyConfirmPassword && defaultPassword.isSubmitted}"
                   (blur)="validateDefaultPasswordForm()" formControlName="confirmPassword" (keyup)="validateDefaultPasswordForm();checkDisabledForgotPassword()" />
            <span title="{{header.confirmPasswordMatchLbl?header.confirmPasswordMatchLbl:headerText.confirmPasswordMatchLbl}}" *ngIf="defaultPassword.isPasswordNotMatched" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button tabindex="3" type="Submit" class="m-3 btn btn-success dialogBtnSize" kendoButton [disabled]="disableForgotPassword" #saveForgotPassword>
                  {{header.saveLbl?header.saveLbl:headerText.saveLbl}}<kendo-loader *ngIf="passwordSaveInProcess" style="color:blue"></kendo-loader>
                </button>
                <button tabindex="4" type="reset" (click)="closeDefaultPasswordDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton [disabled]="passwordSaveInProcess">
                  {{header.closeLbl?header.closeLbl:headerText.closeLbl}}
                </button> &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </form>
    </kendo-dialog>
  </section>
  <div class="passwordChange-wrapper">
    <kendo-dialog *ngIf="openedPassword" (close)="close('cancel')" [minWidth]="250" [width]="450">
      <p style="margin: 30px; text-align: center; font-size:20px;">
        <strong>{{header.thanksLbl?header.thanksLbl:headerText.thanksLbl}},&nbsp;</strong> {{userId}}!<br />
        {{header.passwordUpdateSuccessfulLbl?header.passwordUpdateSuccessfulLbl:headerText.passwordUpdateSuccessfulLbl}}.
      </p>

      <!--<button kendoButton (click)="close('yes')" primary="true">Yes</button>-->
      <div class=text-center>
        <button kendoButton primary="true" (click)="closePassword()" class="">
          {{header.okLbl?header.okLbl:headerText.okLbl}}
        </button>
      </div>
    </kendo-dialog>
  </div>
  <!--end passwordChange-wrapper-->
  <!--modal dialog for user terms and condition agreement-->
  <section class="dialogSection">
    <kendo-dialog  title="{{header.termsConditionTitle?header.termsConditionTitle:headerText.termsConditionTitle}}" 
    *ngIf="termsConditionAgreement.opened" (close)="closeTermsConditionDialog()"  style="min-width:600px important;">
      <div>
      <div class="col-sm-12" style="border: 1px solid black;">
        <!--<div style="height:200px; overflow:auto; padding:1.143em; margin:-1.143em;">
      <app-terms-and-conditions></app-terms-and-conditions>
    </div>-->
        <div style="padding:5px;">
          <b>{{header.termsConditionMessage1?header.termsConditionMessage1:headerText.termsConditionMessage1}}
            <a style="color: #007ad9;" [routerLink]="" (click)="openTermsCondition();">{{header.termsConditionTxt?header.termsConditionTxt:headerText.termsConditionTxt}}</a></b>
        </div>
        <br/>
        <div style="padding:5px;">
          <b> {{header.termsConditionMessage2?header.termsConditionMessage2:headerText.termsConditionMessage2}}</b>
        </div>
        </div>
        <div style="padding:5px;">
          <span style="color:red;">{{header.termsConditionNote?header.termsConditionNote:headerText.termsConditionNote}}</span>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center" style="text-align:center !important;">
            <div class="btn-group" role="group">
              <button (click)="closeTermsConditionDialog()" class="k-button dialogBtnSize" kendoButton [disabled]="inProgress || !termsConditionAgreement.isRead">
                {{header.disagreeLbl?header.disagreeLbl:headerText.disagreeLbl}}
              </button> &nbsp;&nbsp;
              <button (click)="termsConditionSubmit('agree')" class="btn-success dialogBtnSize" kendoButton
                      [disabled]="inProgress || !termsConditionAgreement.isRead">
                {{header.agreeLbl?header.agreeLbl:headerText.agreeLbl}}<kendo-loader *ngIf="inProgress" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
</kendo-dialog>
    </section>
  </div>
  <!--end Logged In header-container-->
        <!--start - BroadCast Messaging-->
        <div class="row" style="height: 25px; background-color: #ff9999" *ngIf="showMenu && broadCastMessage">
          <div style="position:absolute; z-index:1000; left:50%;"><span style="color:white;">{{broadCastMessage}}</span></div>
        </div>
        <!--end - BroadCast Messaging-->
